export const environment = {
  production: true,
  envName: 'telkom',
  apiUrl: 'https://telkomruby-rest.procleus.com/',
  onboardingCookie: "Ruby_Telkom_OnboardingDismissed",
  onboardingStepsPath: "assets/json/OnBoarding/steps_telkom.json"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts